import script from "./ImageStep.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageStep.vue?vue&type=script&setup=true&lang=js"

import "./ImageStep.vue?vue&type=style&index=0&id=2dedfab4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dedfab4"]])

export default __exports__